module.exports = __webpack_public_path__ + "865eca2f3f6da3fed348430ad144b575.svg";